import styled from "styled-components";
import { SE_CLIENT_HEIGHT } from "../../../constants/data";

const FinishEmailBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: ${SE_CLIENT_HEIGHT}px;
  position: relative;
  overflow: hidden;
  padding: 7px 0 35px 0;
  justify-content: space-between;
  box-sizing: border-box;
  .blue {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
  }
  .purple {
    position: absolute;
    top: 300px;
    right: 0;
    display: block;
`;

FinishEmailBlock.Top = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: calc(100% - 20px);
    max-width: 600px;
  }
  .premium {
    color: white;
    text-transform: uppercase;
    background: #f37f3d;
    border-radius: 6px;
    padding: 2px 5px;
    font-size: 14px;
  }
`;
FinishEmailBlock.Center = styled.div`
  z-index: 2;
  .premium {
    color: white;
    text-transform: uppercase;
    background: #f37f3d;
    border-radius: 6px;
    padding: 2px 5px;
    font-size: 14px;
  }
  .finish {
    margin-top: -90px;
    @media (max-height: ${SE_CLIENT_HEIGHT}px) {
      margin-top: -155px;
    }
  }
`;
FinishEmailBlock.Bottom = styled.div`
  z-index: 2;
`;

export { FinishEmailBlock };
